import { useTranslation } from 'react-i18next';
import { Divider, Button } from '@treezor/design-system';

import { useGetPasskey } from '../hooks/useGetPasskey';

export function Auth2FaAuthenticationFail() {
  const { t } = useTranslation();
  const { isLoading, isDisabled, authenticate2FA } = useGetPasskey();

  return (
    <div className="flex flex-col">
      <span className="typo-body-regular-paragraphLarge text-primary">
        {t('pages.auth.2fa.authenticationFailTitle')}
      </span>
      <Divider className="my-4" />
      <span className="typo-body-semibold-paragraph text-secondary mb-2">
        {t('pages.auth.2fa.failDescription.title')}
      </span>
      <>
        {['0', '1'].map((key) => (
          <span key={`fail-description-${key}`} className="typo-body-regular-paragraph text-secondary">
            {t(`pages.auth.2fa.failDescription.${key}`)}
          </span>
        ))}
      </>
      <Button onClick={authenticate2FA} disabled={isDisabled} isLoading={isLoading} className="w-fit mt-6">
        {t('pages.cores.tryAgain')}
      </Button>
    </div>
  );
}
